(() => {
  if (window.PuzzlePupPdpPurchase) return;

  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD'
  }).format(Number(cents || 0) / 100);
  const form = () => document.querySelector('[data-pp-canonical-form]');
  const selectedPackage = root => root?.querySelector('[data-pp-package]:checked');
  const selectedPurchase = root => root?.querySelector('[data-pp-purchase-type]:checked')?.value || 'one-time';
  const addonSelected = root => root?.querySelector('[data-pp-mat-addon-check]')?.checked === true && ['mat-with-treats', 'mat-only', 'two-mats'].includes(selectedPackage(root)?.value);
  const addonOption = root => root?.querySelector('[data-pp-mat-addon-select]')?.selectedOptions?.[0];
  const addonPrice = root => Number(addonOption(root)?.dataset.addonPriceCents || 1749);
  function syncAddon(root) {
    const wrap = root.querySelector('[data-pp-mat-addon]');
    if (!wrap) return;
    const eligible = ['mat-with-treats', 'mat-only', 'two-mats'].includes(selectedPackage(root)?.value);
    wrap.hidden = !eligible;
    if (!eligible) wrap.querySelector('[data-pp-mat-addon-check]').checked = false;
    const select = wrap.querySelector('[data-pp-mat-addon-select]');
    wrap.querySelectorAll('[data-pp-mat-addon-image]').forEach(image => { image.hidden = image.dataset.ppMatAddonImage !== select.value; });
    wrap.querySelector('[data-pp-mat-addon-benefit]').textContent = select.selectedOptions[0]?.dataset.addonBenefit || '';
    const option = addonOption(root);
    const price = wrap.querySelector('[data-pp-addon-price]');
    const regular = wrap.querySelector('[data-pp-addon-regular]');
    const hint = wrap.querySelector('[data-pp-addon-hint]');
    if (price) price.textContent = money(addonPrice(root));
    if (regular) regular.textContent = money(option?.dataset.addonRegularCents || 3499);
    if (hint) hint.textContent = `Just ${money(addonPrice(root))} with your Mat · normally ${money(option?.dataset.addonRegularCents || 3499)}`;
  }
  const track = (eventName, payload) => window.PuzzlePupAnalytics?.track(eventName, payload);

  function syncPlans(root, packageInput) {
    const select = root?.querySelector('[data-pp-frequency]');
    if (!select) return null;
    for (const option of select.options) {
      let prices = {};
      let refillPrices = {};
      try { prices = JSON.parse(option.dataset.variantPrices || '{}'); } catch (_) { /* Unavailable until valid plan data is rendered. */ }
      try { refillPrices = JSON.parse(option.dataset.variantRefillPrices || '{}'); } catch (_) { refillPrices = {}; }
      const price = prices[packageInput?.dataset.variantId];
      const refillPrice = refillPrices[packageInput?.dataset.variantId];
      const available = typeof price === 'number' && Number.isFinite(price) && price >= 0;
      option.disabled = !available;
      option.hidden = !available;
      option.dataset.priceCents = available ? String(price) : '';
      option.dataset.refillPriceCents = typeof refillPrice === 'number' && Number.isFinite(refillPrice) ? String(refillPrice) : (available ? String(price) : '');
    }
    if (!select.selectedOptions[0] || select.selectedOptions[0].disabled) {
      select.selectedIndex = Array.from(select.options).findIndex(option => !option.disabled);
    }
    const option = select.selectedOptions[0];
    return option && !option.disabled ? Number(option.dataset.priceCents) : null;
  }

  function updateShipping(root, selectedTotal, subscription) {
    const buybox = root?.closest('[data-pp-buybox]');
    const message = buybox?.querySelector('[data-pp-shipping-message]');
    if (!buybox || !message) return;
    const threshold = Number(buybox.dataset.shippingThresholdCents || 3498);
    const cartTotal = Number(buybox.dataset.cartTotalCents || 0);
    const packageTotal = Number(selectedTotal || 0);
    if (subscription) message.textContent = '✓ Free U.S. shipping on scheduled deliveries';
    else if (cartTotal >= threshold) message.textContent = '✓ Your cart qualifies for free U.S. shipping';
    else if (packageTotal >= threshold) message.textContent = '✓ This package qualifies for free U.S. shipping';
    else if (cartTotal > 0) message.textContent = `Your cart needs ${money(threshold - cartTotal)} more for free U.S. shipping`;
    else message.textContent = `Free U.S. shipping on orders ${money(threshold)}+`;
  }

  function update(root = form()) {
    if (!root) return;
    let packageInput = selectedPackage(root);
    const purchaseType = selectedPurchase(root);
    const subscription = purchaseType === 'subscription';
    const oneTimeOnly = root.querySelectorAll('[data-pp-one-time-package]');
    if (subscription && packageInput?.closest('[data-pp-one-time-package]')) {
      const options = [...root.querySelectorAll('[data-pp-package]')].filter(input => !input.closest('[data-pp-one-time-package]'));
      packageInput = options.find(input => input.dataset.variantId === packageInput.dataset.variantId) || options[0];
      if (packageInput) packageInput.checked = true;
    }
    oneTimeOnly.forEach(option => { option.hidden = subscription; });
    const pairWrap = root.querySelector('[data-pp-pair-wrap]');
    if (pairWrap) pairWrap.hidden = subscription || !['two', 'mat-plus-jar'].includes(packageInput?.value);

    const planWrap = root.querySelector('[data-pp-frequency-wrap]');
    const planSelect = root.querySelector('[data-pp-frequency]');
    const planInput = root.querySelector('[data-pp-selling-plan]');
    const planPrice = syncPlans(root, packageInput);
    if (planWrap) planWrap.hidden = !subscription;
    if (planInput) planInput.value = subscription ? (planSelect?.value || '') : '';
    const variantInput = root.querySelector('[data-pp-variant-id]');
    const quantityInput = root.querySelector('[data-pp-quantity]');
    if (variantInput && packageInput) variantInput.value = packageInput.dataset.variantId;
    if (quantityInput && packageInput) quantityInput.value = packageInput.dataset.quantity || '1';

    syncAddon(root);
    const addonCents = addonSelected(root) ? addonPrice(root) : 0;
    const cents = subscription
      ? Number(planPrice || 0) * Number(packageInput?.dataset.quantity || 1)
      : Number(packageInput?.dataset.priceCents || 0) + addonCents;
    const available = packageInput?.dataset.available !== 'false' && (!subscription || planPrice !== null);
    const unitPrice = Number(packageInput?.dataset.regularCents || packageInput?.dataset.priceCents || 0) / Number(packageInput?.dataset.quantity || 1);
    const savings = planPrice !== null && unitPrice > 0 ? Math.round((unitPrice - planPrice) * 100 / unitPrice) : 0;
    const refillPrice = planSelect?.selectedOptions[0]?.dataset.refillPriceCents ? Number(planSelect.selectedOptions[0].dataset.refillPriceCents) : planPrice;
    const changesAfterFirst = planPrice !== null && refillPrice !== null && refillPrice !== planPrice;
    const savingsText = changesAfterFirst ? `${savings}% off your first delivery; refills ${money(refillPrice)}` : savings > 0 ? `${savings}% off the one-time price` : 'Price for your selected plan';
    document.querySelectorAll('[data-pp-value-refill-price]').forEach(node => { node.textContent = refillPrice === null ? 'Unavailable for this option' : money(refillPrice); });
    document.querySelectorAll('[data-pp-subscription-savings]').forEach(node => { node.textContent = savingsText; });
    document.querySelectorAll('[data-pp-value-regular-price]').forEach(node => { node.textContent = money(unitPrice); });
    document.querySelectorAll('[data-pp-value-subscription-price]').forEach(node => { node.textContent = planPrice === null ? 'Unavailable for this option' : money(planPrice); });
    const title = (packageInput?.dataset.title || 'Your package') + (addonSelected(root) ? ' + ' + root.querySelector('[data-pp-mat-addon-select]').selectedOptions[0].dataset.addonName : '');
    const formatted = money(cents);
    document.querySelectorAll('[data-pp-display-price],[data-pp-sticky-price],[data-pp-drawer-price]').forEach(node => { node.textContent = formatted; });
    document.querySelectorAll('[data-pp-drawer-package]').forEach(node => { node.textContent = title; });
    document.querySelectorAll('[data-pp-drawer-purchase-type]').forEach(node => { node.textContent = subscription ? 'Subscription' : 'One-time purchase'; });

    const summaryHeading = root.querySelector('[data-pp-summary-heading]');
    const summaryLine = root.querySelector('[data-pp-savings-line]');
    const summary = root.querySelector('[data-pp-subscription-summary]');
    const frequency = root.querySelector('[data-pp-subscription-frequency]');
    const totalDue = root.querySelector('[data-pp-total-due]');
    if (summaryHeading) summaryHeading.textContent = subscription ? 'Due today' : 'Your package';
    if (summaryLine) summaryLine.textContent = subscription
      ? savingsText
      : (Number(packageInput?.dataset.quantity || 1) > 1 || ['mat-plus-jar', 'mat-with-treats'].includes(packageInput?.value) ? `${title} · ${formatted}` : 'One-time purchase');
    if (summary) summary.hidden = !subscription;
    if (frequency) frequency.textContent = planSelect?.selectedOptions?.[0]?.textContent?.trim() || 'Choose a flexible delivery schedule';
    if (totalDue) totalDue.textContent = formatted;
    const submit = root.querySelector('[data-pp-product-submit]');
    if (submit) {
      const busy = root.getAttribute('aria-busy') === 'true';
      submit.disabled = busy || !available;
      submit.textContent = busy ? 'Adding and checking price...' : available ? `Add to cart · ${formatted}` : (subscription && planPrice === null ? 'Subscription unavailable for this option' : 'Sold out');
    }
    updateShipping(root, cents, subscription);
    document.dispatchEvent(new CustomEvent('pp:purchase-state', { detail: { title, cents, purchaseType } }));
  }

  async function refreshAndOpenCart() {
    const cartUrl = (window.Shopify?.routes?.root || '/') + 'cart';
    try {
      await window.PuzzlePupOfferEngine?.refreshCartSurfaces?.();
      const drawer = document.querySelector('cart-drawer');
      if (typeof drawer?.open === 'function') drawer.open();
      else window.location.assign(cartUrl);
    } catch (_) {
      window.location.assign(cartUrl);
    }
  }

  document.addEventListener('change', event => {
    if (!event.target.matches('[data-pp-package],[data-pp-purchase-type],[data-pp-frequency],[data-pp-pair-select],[data-pp-mat-addon-check],[data-pp-mat-addon-select]')) return;
    const root = event.target.closest('[data-pp-canonical-form]');
    if (event.target.matches('[data-pp-package]')) {
      const purchaseType = selectedPurchase(root);
      track('pp_package_select', {
        package: event.target.value,
        package_title: event.target.dataset.title,
        variant_id: event.target.dataset.variantId,
        quantity: Number(event.target.dataset.quantity || 1),
        regular_price: Number(event.target.dataset.regularCents || event.target.dataset.priceCents || 0),
        effective_price: purchaseType === 'subscription'
          ? Number(event.target.dataset.subPriceCents || event.target.dataset.priceCents || 0)
          : Number(event.target.dataset.priceCents || 0)
      });
    } else if (event.target.matches('[data-pp-purchase-type]')) {
      track('pp_purchase_type_select', { purchase_type: event.target.value });
    } else {
      const option = event.target.selectedOptions?.[0];
      track('pp_frequency_select', {
        selling_plan_id: event.target.value,
        frequency_label: option?.textContent?.trim(),
        effective_price: Number(option?.dataset.priceCents || 0)
      });
    }
    update(root);
  });

  document.addEventListener('submit', async event => {
    const root = event.target.closest('[data-pp-canonical-form]');
    if (!root) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (root.getAttribute('aria-busy') === 'true') return;
    const submit = root.querySelector('[data-pp-product-submit]');
    const error = root.querySelector('[data-pp-form-error]');
    const packageInput = selectedPackage(root);
    const variantId = Number(root.querySelector('[data-pp-variant-id]')?.value || 0);
    const quantity = Number(root.querySelector('[data-pp-quantity]')?.value || 1);
    const purchaseType = selectedPurchase(root);
    const selectedPlanPrice = syncPlans(root, packageInput);
    const planId = purchaseType === 'subscription'
      ? Number(root.querySelector('[data-pp-frequency]')?.value || 0)
      : 0;
    const planInput = root.querySelector('[data-pp-selling-plan]');
    if (planInput) planInput.value = planId ? String(planId) : '';
    const expectedPrice = planId
      ? Number(selectedPlanPrice) * quantity
      : Number(packageInput?.dataset.priceCents || 0) + (addonSelected(root) ? addonPrice(root) : 0);
    const original = submit?.textContent || '';
    if (!variantId) return;
    if (error) { error.hidden = true; error.textContent = ''; }
    if (purchaseType === 'subscription' && (!planId || selectedPlanPrice === null)) {
      if (error) { error.hidden = false; error.textContent = 'Please choose an available subscription plan for this option.'; }
      return;
    }
    root.setAttribute('aria-busy', 'true');
    if (submit) { submit.disabled = true; submit.textContent = 'Adding and checking price...'; }
    try {
      if (typeof window.PuzzlePupOfferEngine?.addAndVerify !== 'function') throw new Error('Offer verification is still loading. Please try again.');
      const mainItem = { id: variantId, quantity, expectedLineTotal: expectedPrice };
      const items = [mainItem];
      if (!planId && ['two', 'mat-plus-jar'].includes(packageInput?.value)) {
        const secondId = Number(root.querySelector('[data-pp-pair-select]')?.value || 0);
        if (!secondId) throw new Error('Please choose an available second product.');
        mainItem.quantity = 1;
        items.push({ id: secondId, quantity: 1, expectedLineTotal: 0 });
      }
      if (addonSelected(root)) {
        const addonId = Number(root.querySelector('[data-pp-mat-addon-select]')?.value || 0);
        if (!addonId) throw new Error('Choose an available extra.');
        items.push({ id: addonId, quantity: 1, properties: { _PuzzlePup_offer: 'Mat 50% off extra' } });
      }
      if (planId) mainItem.selling_plan = planId;
      const verified = await window.PuzzlePupOfferEngine.addAndVerify({
        items,
        expectedMaxIncrease: expectedPrice,
        source: 'pdp_buybox',
        offerId: `${packageInput?.value || 'package'}-${planId ? 'subscription' : 'one-time'}`,
        successEvent: 'pp_offer_verified'
      });
      track('pp_add_to_cart', {
        variant_id: variantId,
        package: packageInput?.value || '',
        purchase_type: planId ? 'subscription' : 'one-time',
        selling_plan_id: planId || undefined,
        quantity,
        regular_price: Number(packageInput?.dataset.regularCents || packageInput?.dataset.priceCents || 0),
        effective_price: expectedPrice,
        resulting_cart_total: Number(verified.cart?.total_price || 0)
      });
      const buybox = root.closest('[data-pp-buybox]');
      if (buybox) buybox.dataset.cartTotalCents = String(verified.cart?.total_price || 0);
      await refreshAndOpenCart();
      document.querySelectorAll('.pp-v3-drawer').forEach(drawer => {
        if (!drawer.hidden) window.PuzzlePupPdpDrawers?.close(drawer, false);
      });
    } catch (requestError) {
      if (error) { error.hidden = false; error.textContent = requestError.message || 'This item could not be added.'; }
    } finally {
      root.removeAttribute('aria-busy');
      if (submit) { submit.disabled = false; submit.textContent = original; update(root); }
    }
  }, true);

  async function syncCartTotal() {
    try {
      const currentCart = await window.PuzzlePupOfferEngine?.cart?.();
      const buybox = document.querySelector('[data-pp-buybox]');
      if (buybox && currentCart) buybox.dataset.cartTotalCents = String(currentCart.total_price || 0);
    } catch (error) {
      return update(form());
    }
    update(form());
  }

  const init = () => update(form());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('pp:cart-updated', syncCartTotal);
  window.PuzzlePupPdpPurchase = Object.freeze({ update });
})();



